import { createSelector } from '@ngrx/store';
import { callLogsRegisterSelector } from './call-logs-register.reducer';

export const selectFilters = createSelector(callLogsRegisterSelector, (state) => {
   return state.filters;
});

export const selectQuickFilters = createSelector(callLogsRegisterSelector, (state) => state.quickFilters);
